import { render } from "./MedicalExaminationProcess.vue?vue&type=template&id=96a96c8a&ts=true"
import script from "./MedicalExaminationProcess.vue?vue&type=script&lang=ts"
export * from "./MedicalExaminationProcess.vue?vue&type=script&lang=ts"

import "./MedicalExaminationProcess.vue?vue&type=style&index=0&id=96a96c8a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__